import { parsePhoneNumber } from 'libphonenumber-js';
import React from 'react';

interface PhoneNumberDisplayProps {
    phoneNumber: string;
    className?: string;
    showLink?: boolean;
}

const PhoneNumberDisplay: React.FC<PhoneNumberDisplayProps> = ({ phoneNumber, className = '', showLink = true }) => {
    const formatPhoneNumber = (phone: string) => {
        if (!phone) return '';

        try {
            const cleanedNumber = phone.replace(/[^\d+]/g, '');
            const phoneWithPlus = cleanedNumber.startsWith('+') ? cleanedNumber : `+${cleanedNumber}`;
            const parsedNumber = parsePhoneNumber(phoneWithPlus);

            if (parsedNumber) {
                const countryCode = parsedNumber.countryCallingCode;
                const nationalNumber = parsedNumber.nationalNumber;
                let formattedNumber: string;

                switch (parsedNumber.country) {
                    case 'US': {
                        formattedNumber = `+${countryCode} (${nationalNumber.slice(0, 3)}) ${nationalNumber.slice(3, 6)}-${nationalNumber.slice(6)}`;
                        break;
                    }

                    case 'CA': {
                        formattedNumber = `+${countryCode} (${nationalNumber.slice(0, 3)}) ${nationalNumber.slice(3, 6)}-${nationalNumber.slice(6)}`;
                        break;
                    }

                    default: {
                        formattedNumber = parsedNumber.formatInternational();
                        break;
                    }
                }

                return formattedNumber;
            }
        } catch (error) {
            console.error('Error formatting phone number:', error);
        }

        const cleaned = phone.replace(/\D/g, '');

        if (cleaned.length === 10) {
            return `+1 (${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        } else if (cleaned.length === 11 && cleaned.startsWith('1')) {
            return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
        }

        return phone.startsWith('+') ? phone : `+${phone}`;
    };

    const formattedNumber = formatPhoneNumber(phoneNumber);

    if (!formattedNumber) return null;

    if (showLink) {
        return (
            <a href={`tel:${phoneNumber}`} className={className}>
                {formattedNumber}
            </a>
        );
    }

    return <span className={className}>{formattedNumber}</span>;
};

export default PhoneNumberDisplay;
